module.exports = __webpack_public_path__ + "media/images/general/sns/logo-twitter-fb247d9ac6c880effaa25140e082e56e.svg";